(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sz-collection-autoplay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sz-collection-autoplay')) {
  customElements.define('sz-collection-autoplay', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slider = this.parentElement.querySelector('slider-component ul');
      if (!this.slider) return;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.touching = false;
      this.visible = false;
      this.lastInteraction = 0;
      this.slider.addEventListener('pointerdown', () => { this.touching = true; }, {signal, passive:true});
      window.addEventListener('pointerup', () => { this.touching = false; this.lastInteraction = Date.now(); }, {signal, passive:true});
      window.addEventListener('pointercancel', () => { this.touching = false; this.lastInteraction = Date.now(); }, {signal, passive:true});
      this.slider.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; }, {signal});
      this.slider.addEventListener('pointerleave', () => { this.hovered = false; this.lastInteraction = Date.now(); }, {signal});
      this.parentElement.querySelector('slider-component').addEventListener('click', () => { this.lastInteraction = Date.now(); }, {signal});
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold:0.15});
      this.observer.observe(this.slider);
      this.timer = setInterval(() => {
        if (this.paused || this.hovered || this.touching || !this.visible || document.hidden || this.slider.contains(document.activeElement) || Date.now() - this.lastInteraction < 3000) return;
        const max = this.slider.scrollWidth - this.slider.clientWidth;
        const slides = this.slider.children;
        if (max <= 2 || slides.length < 2) return;
        const step = slides[1].offsetLeft - slides[0].offsetLeft;
        this.slider.scrollTo({ left: this.slider.scrollLeft >= max - 2 ? 0 : Math.min(max, this.slider.scrollLeft + step), behavior:'smooth' });
      }, 3000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sz-snatched-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sz-snatched-countdown')) {
    customElements.define('sz-snatched-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.launchAt);
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.onVisible = () => this.update();
        if (!Number.isFinite(this.deadline) || !this.hours || !this.minutes || !this.seconds) return;
        if (!this.update()) return;
        this.interval = window.setInterval(() => this.update(), 1000);
        document.addEventListener('visibilitychange', this.onVisible);
      }
      update() {
        const remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          this.hidden = true;
          this.remove();
          return false;
        }
        const total = Math.ceil(remaining / 1000);
        this.hours.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
        this.minutes.textContent = String(Math.floor(total / 60) % 60).padStart(2, '0');
        this.seconds.textContent = String(total % 60).padStart(2, '0');
        this.hidden = false;
        return true;
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisible);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
